import { UserPage } from 'widgets/user/ui/UserPage';

export const UserMPPage = () => <UserPage />;
